import React from 'react'
import { observer } from 'mobx-react-lite'
import {
  Card,
  CardHeader,
  CardTitle,
  CardTitleCount,
  CardContent,
} from 'components/Card'
import JobViewModel from '../JobViewModel'
import styles from './ResponsesCard.sass'
import { SectionError, SectionLoading } from '../Section/Section'
import { QuestionDTO } from 'jobs/dtos/questions'
import { QuestionViewModelFor } from 'jobs/questions/type-registry'
import ResponseValue from 'jobs/components/ResponseValue'

interface ResponseItemProps<T extends QuestionDTO> {
  questionVM: QuestionViewModelFor<T>
}

function Response<T extends QuestionDTO>({ questionVM }: ResponseItemProps<T>) {
  return (
    <div className={styles.responseItem}>
      <div className={styles.responseItemLabel}>{questionVM.question}</div>
      <div className={styles.responseItemValue}>
        <ResponseValue vm={questionVM} />
      </div>
    </div>
  )
}

interface Props {
  vm: JobViewModel
}

export default observer(function ResponsesCard({ vm }: Props) {
  React.useEffect(() => {
    // Always show the responses by default when the component is first mounted
    vm.detailsVM.responsesSection.set(true)
  }, [vm.detailsVM.responsesSection])

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          Onboarding questions
          <CardTitleCount>
            ({vm.detailsVM.responses.questions.length || vm.job.answers.length})
          </CardTitleCount>
        </CardTitle>
      </CardHeader>
      <CardContent scroll>
        {vm.detailsVM.fetchResponses.match({
          pending: () => <SectionLoading />,
          rejected: (err) => (
            <SectionError title="Error loading responses." error={err} />
          ),
          resolved: () =>
            vm.detailsVM.responses.questions.map((q) => (
              <Response key={q.id} questionVM={q} />
            )),
        })}
      </CardContent>
    </Card>
  )
})
